<div class="status-tabs-wrap">
  <span class="status-tabs-label">Status</span>
  <div class="status-tabs" role="tablist" aria-label="Employee status">
    <button
      type="button"
      role="tab"
      *ngFor="let tab of visibleTabs"
      class="status-tab"
      [class.status-tab--active]="tab.value === selectedValue"
      [attr.aria-selected]="tab.value === selectedValue"
      (click)="selectTab(tab.value)">
      <span class="status-tab__label">{{ tab.label }}</span>
      <span class="status-tab__count">{{ tabCounts[tab.value] }}</span>
    </button>
  </div>
</div>
